import {
    useOpenConversationWithEnterKey,
    useSelectConversationWithSpaceBar,
    useDeselectConversationWithEscape,
    useToggleFilterModalWithFKey,
} from 'src/pages/landlord/conversations/components/key-listener/hooks';
import type { IConversation } from 'src/api/landlord-messages-api';
import type { IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context/types';

type Props = {
    selectedConversations: Array<IConversation | IConversationMatchWithChannel>;
    getFocusedConversation: () => IConversation | undefined;
    setSelectedConversations: React.Dispatch<React.SetStateAction<Array<IConversation | IConversationMatchWithChannel>>>;
    openConversation: (conversation: IConversation | IConversationMatchWithChannel, backPath: string) => void;
    setFilterOpen: (open: boolean) => void;
};

export default function ConversationsKeyListener({
    getFocusedConversation,
    selectedConversations,
    setSelectedConversations,
    openConversation,
    setFilterOpen,
}: Props) {
    useSelectConversationWithSpaceBar({
        getFocusedConversation,
        setSelectedConversations,
    });
    useDeselectConversationWithEscape({
        selectedConversations,
        setSelectedConversations
    });
    useOpenConversationWithEnterKey({
        getFocusedConversation,
        openConversation
    });
    useToggleFilterModalWithFKey({
        setFilterOpen
    });

    return null;
}
